<template>
    <div class="row">
        <div class="col">
            <label for="country_id">Country *</label>
            <select id="country_id" name="country_id" class="form-control" v-model="countryId" @change="getStates()">
                <option value="" >Select Country</option>
                <option v-for="data in countries" :value="data.id">{{ data.name }}</option>
            </select>
        </div>

        <div class="col">
          <div v-if="states.length">
            <label for="state_id">State *</label>
            <select id="state_id" name="state_id" class="form-control" v-model="stateId">
                <option value="" >Select State</option>
                <option v-for="data in states" :value="data.id">{{ data.name }}</option>
            </select>
          </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "CountryStatePicker",
        data(){
            return {
                countries: [],
                states: []
            }
        },
        props: ['stateId', 'countryId', 'stateError'],
        methods:{
            getCountries: function(){
                axios.get('/api/countries')
                    .then(function (response) {
                        this.countries = response.data.data;
                    }.bind(this));

            },
            getStates: function() {
                axios.get('/api/states-by-country',{
                    params: {
                        country_id: this.countryId
                    }
                }).then(function(response){
                    this.states = response.data.data;
                }.bind(this));
            }
        },
        created: function(){
            this.getCountries();

            if (this.countryId) {
                this.getStates();
            }
        }
    }
</script>

<style scoped>

</style>
